import { PresenceType, useIdleTimer } from "react-idle-timer";
import { useAppDispatch } from "hooks/redux";
import { showTimeoutMessage, closeTimeoutModal } from "store/timeoutModalSlice";


// TODO: add logout prop (gov / vendor)
const useSessionTimeout = (timeout: number,  promptBeforeIdle: number, onLogout: () => void) => {

    const dispatch = useAppDispatch();

    const onPresenceChange = (presence: PresenceType) => {
      const isIdle = presence.type === "idle";
      const isPrompted = presence.type === "active" && presence.prompted;
      const isActive = presence.type === "active" && !presence.prompted;

      if (isPrompted) {
        //console.log("Prompted");
        //console.log("Prompt Timeout!");
        dispatch(
          showTimeoutMessage({
            getRemainingTime: onGetRemainingTime,
            onTimeout: onIdle,
            onStayLoggedIn,
          })
        );
        
      } 
    };

    const onIdle = () => {
      
      //TODO: Autosave

      dispatch(closeTimeoutModal());
      onLogout();
      //TODO: Logout
    };

    const { getRemainingTime, activate } = useIdleTimer({
      onPresenceChange,
      onIdle,
      timeout: timeout,
      promptBeforeIdle: promptBeforeIdle,
      throttle: 200,
    });

    const onGetRemainingTime = () =>{

      return getRemainingTime();
    }

    const onStayLoggedIn = () => {     
      activate();
       dispatch(closeTimeoutModal());
    };



}

export default useSessionTimeout;